export const basicError = 'Sorry. Something went wrong. Please try it later';

export const basicSuccess = 'Successful!';
